import { FormStore, GlobalStore } from '@roc/feature-app-core';

/**
 * The bank step's typed fields when the account comes from Plaid: bank name, numbers, account type and the name on the
 * account all come from Plaid, so only the payment day is asked.
 */
const form = {
  fields: {
    withdrawalDay: {
      value: 1,
      error: null,
      rule: 'required',
      attribute: 'withdrawal day',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class PlaidBankInformationFormStore extends FormStore {
  constructor(globalStore: GlobalStore) {
    super(form, globalStore);
  }
}
